import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import { useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import {
  ROUTE_OFFICIALS,
  ROUTE_OFFICIALS_LIST,
  ROUTE_OFFICIALS_ADD,
  ROUTE_OFFICIALS_EDIT,
  ROUTE_APPLICANTS_EDIT,
  ROUTE_OFFICIALS_PASSWORD_SECURITY,
} from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { OfficialsListView } from './OfficialsList/OfficialsList.view';
import { AddOfficialsView } from './OfficialsEditor/AddOfficials.view';
import { EditOfficialsView } from './OfficialsEditor/EditOfficials.view';
import { EditApplicantsView } from './OfficialsEditor/EditApplicants.view';
import { PasswordSecurityView } from './PasswordSecurity/PasswordSecurity.view';
import { NotFoundView } from 'views/Errors/NotFound.view';

export const OfficialsView: React.FC = () => {
  const trans = useTranslator();

  return (
    <React.Fragment>
      <Breadcrumb label={trans('BREADCRUMB.OFFICIALS.TITLE')} static />
      <Routes>
        <Route path={relativePath(ROUTE_OFFICIALS, ROUTE_OFFICIALS)} element={<Navigate to={ROUTE_OFFICIALS_LIST} replace />} />
        <Route path={relativePath(ROUTE_OFFICIALS_LIST, ROUTE_OFFICIALS)} element={<OfficialsListView />} />
        <Route path={relativePath(ROUTE_OFFICIALS_ADD, ROUTE_OFFICIALS)} element={<AddOfficialsView />} />
        <Route path={relativePath(ROUTE_OFFICIALS_PASSWORD_SECURITY, ROUTE_OFFICIALS)} element={<PasswordSecurityView />} />
        <Route path={relativePath(ROUTE_APPLICANTS_EDIT, ROUTE_OFFICIALS)} element={<EditApplicantsView />} />
        <Route path={relativePath(ROUTE_OFFICIALS_EDIT, ROUTE_OFFICIALS)} element={<EditOfficialsView />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </React.Fragment>
  );
};
